import VueCookies from "vue-cookies";
import { customAction } from "@/data/connection";
import { bus } from "@/main.js";

/**
 * Creates session (with a cookie) with specified token.
 */

export const createSession = function (username, password) {
	if (username && password) {
		// console.debug(`Creating session for user ${username} with password ${password}`);

		const token = btoa(`${username}:${password}`);
		VueCookies.set("token", token, { "expires": "1M" });
	} else {
		// console.debug("Invalid credentials to create a session.");
	}
}

/**
 * Deletes current saved session.
 */
export const deleteSession = function () {
	// console.debug(`Going to delete session`);
	bus.$emit("deleteSession")
	VueCookies.remove("token");
	VueCookies.remove("user");
}

/**
 * Checks if session is present.
 */
export const isLoggedIn = function () {
	if (VueCookies.get("token")) {
		// console.debug("Session appears to be valid!");
		return VueCookies.get("token");
	} else {
		console.warn("No session present!");
		return false;
	}
}


/**
 * Validates with API specified email and password, and creates a session.
 */
export const validateCredentials = async function (username, password) {
	createSession(username, password);
	
	try {
		const response = await customAction("users/me");
		
		// console.log("response:", response)
		
		if (response.status == "200" && response.data.slug === username) {
			const user = {
				id: response.data.id,
				name: response.data.name,
				username: response.data.slug,
			};

			// console.log("set Cookie :", response);
			VueCookies.set("user", user, { "expires": "1M" });
			bus.$emit("userSession");

			return true;
		} else {
			return false;
			deleteSession();
		}
	} catch (error) {
		console.error(`Error validating with API. Error: ${error}`);
		return false;
		deleteSession();
	}
}


// WEBPACK FOOTER //
// ./src/data/authentication.js